<template>
  <div id="spinner">
    <h1>Wat nu wiel</h1>
    <div class="wheel-container">
      <spinner
        :prizes="prizes"
        ref="fSpinner"
      />
      <keuzemenu
        :prizes="prizes"
        :spinner="$refs.fSpinner"
      />
    </div>
  </div>
</template>

<script>
  import { Vue, Component } from "vue-property-decorator";
  import { Persist } from "vue-persist-decorator";
  import Spinner from "./components/Spinner.vue";
  import Keuzemenu from "./components/Keuzemenu.vue";

  @Component({
    name: "App",
    components: {
      Spinner,
      Keuzemenu
    }
  })
  class App extends Vue {
    @Persist()
    prizes = [
      {
        id: 1,
        name: "Rekenen",
        value: "Rekenen",
        bgColor: "#EA5503",
        color: "#000000",
        weight: 1
      },
      {
        id: 2,
        name: "Taal",
        value: "Taal",
        bgColor: "#104b8c",
        color: "#000000",
        weight: 1
      },
      {
        id: 3,
        name: "Buiten spelen",
        value: "Buiten spelen",
        bgColor: "#1a7ec4",
        color: "#ffffff",
        weight: 1
      },
      {
        id: 4,
        name: "Knutselen",
        value: "Knutselen",
        bgColor: "#5ba7dd",
        color: "#ffffff",
        weight: 1
      }
    ];

    mounted() {
      this.$nextTick(() => {
        this.$refs.fSpinner.redrawCanvas();
      });
    }
  }
  export default App;
</script>

<style lang="scss" scoped>
h1 {
  font-family: "Vibur", cursive;
  font-size: 5rem;
  letter-spacing: 0.035em;
  color: white;
  text-align: center;
  font-weight: normal;
}

#spinner {
  background-image: repeating-conic-gradient(
    from 3deg at 25% 40%,
    #1A7EC4 0% 5%,
    #104b8c 5% 10%
  );
  @media (max-width: 960px) {
    background-image: repeating-conic-gradient(
      from 3deg at 50% 50%,
      #1A7EC4 0% 5%,
      #104b8c 5% 10%
    );
  }
  background-size: 100% 100%;
  background-position: 50% 50%;
  background-attachment: fixed;
  background-repeat: no-repeat;
}

.wheel-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;

  > div {
    margin: 10px;
  }
}

h1 {
  margin: 0;
}
</style>
